import type { IntegrationSummary, IntegrationStatus } from '@/features/integrations/types'

// Combines the 'gmail' and 'google_calendar' IntegrationSummary rows (both
// already returned by GET /integrations) into one card's worth of status —
// no backend aggregator change needed since connect/disconnect now always
// touch both records together (features/google-workspace on the backend).
export function combineGoogleWorkspaceStatus(
  gmail: IntegrationSummary | undefined,
  calendar: IntegrationSummary | undefined,
): IntegrationStatus {
  if (!gmail || !calendar) return 'not_configured'
  if (gmail.status === 'not_configured' || calendar.status === 'not_configured') return 'not_configured'
  if (gmail.status === 'active' && calendar.status === 'active') return 'active'
  if (gmail.status === 'disconnected' && calendar.status === 'disconnected') return 'disconnected'
  // Any other combination (one connected / one not, or either invalid) means
  // the combined connection isn't fully usable — reconnecting fixes both legs.
  return 'invalid'
}
